export default (regex) => {
  const regexMatch = String(regex).match(/\/(.*)\/(.*)/);
  // eslint-disable-next-line
  const pattern = new RegExp(regexMatch[1], regexMatch[2]);

  return pattern;
};
